import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-obsidian p-8">
          <p className="font-mono text-sm text-white/60">Something broke on this page. Refresh to try again.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
